(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.image-cards');
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    sections.forEach((section) => {
      const track = section.querySelector('[data-cards-track]');
      const cards = section.querySelectorAll('[data-card]');
      const dots  = section.querySelectorAll('[data-card-dot]');

      if (!track || cards.length <= 1) return;

      const getActiveIndex = () => {
        const scrollLeft = track.scrollLeft;
        let closest = 0;
        let minDist = Infinity;
        cards.forEach((card, i) => {
          const dist = Math.abs(card.offsetLeft - track.offsetLeft - scrollLeft);
          if (dist < minDist) {
            minDist = dist;
            closest = i;
          }
        });
        return closest;
      };

      const scrollToCard = (index) => {
        if (!mobileQuery.matches) return;
        const clamped = Math.max(0, Math.min(index, cards.length - 1));
        const target = cards[clamped];
        if (!target) return;
        track.scrollTo({
          left: target.offsetLeft - track.offsetLeft,
          behavior: 'smooth',
        });
      };

      const updateState = () => {
        if (!mobileQuery.matches) {
          dots.forEach((dot, i) => {
            dot.classList.toggle('image-cards__dot--active', i === 0);
            dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          });
          return;
        }

        const active = getActiveIndex();
        dots.forEach((dot, i) => {
          const isActive = i === active;
          dot.classList.toggle('image-cards__dot--active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          scrollToCard(parseInt(dot.dataset.cardDot, 10));
        });
      });

      let scrollTimer;
      track.addEventListener(
        'scroll',
        () => {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(updateState, 80);
        },
        { passive: true }
      );

      mobileQuery.addEventListener('change', updateState);

      updateState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sliders = document.querySelectorAll('.testimonial-slider');

    sliders.forEach((slider) => {
      const track  = slider.querySelector('[data-slider-track]');
      const slides = slider.querySelectorAll('[data-slide]');
      const prev   = slider.querySelector('[data-slider-prev]');
      const next   = slider.querySelector('[data-slider-next]');
      const dots   = slider.querySelectorAll('[data-slider-dot]');

      if (!track || slides.length <= 1) return;

      const getActiveIndex = () => {
        const scrollLeft = track.scrollLeft;
        let closest = 0;
        let minDist = Infinity;
        slides.forEach((slide, i) => {
          const dist = Math.abs(slide.offsetLeft - track.offsetLeft - scrollLeft);
          if (dist < minDist) {
            minDist = dist;
            closest = i;
          }
        });
        return closest;
      };

      const scrollToSlide = (index) => {
        const clamped = Math.max(0, Math.min(index, slides.length - 1));
        const target = slides[clamped];
        if (!target) return;
        track.scrollTo({
          left: target.offsetLeft - track.offsetLeft,
          behavior: 'smooth',
        });
      };

      const updateState = () => {
        const active = getActiveIndex();
        dots.forEach((dot, i) => {
          const isActive = i === active;
          dot.classList.toggle('testimonial-slider__dot--active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        slides.forEach((slide, i) => {
          if (i === active) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
        });
      };

      prev?.addEventListener('click', () => scrollToSlide(getActiveIndex() - 1));
      next?.addEventListener('click', () => scrollToSlide(getActiveIndex() + 1));

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          scrollToSlide(parseInt(dot.dataset.sliderDot, 10));
        });
      });

      let scrollTimer;
      track.addEventListener(
        'scroll',
        () => {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(updateState, 80);
        },
        { passive: true }
      );

      // Recompute on resize (slide widths change)
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateState, 150);
      });

      updateState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
  class VideoSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');

      if (!this.track) return;

      this.#reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.#initDrag();
      this.#initArrows();
      this.#initPlayButtons();
      this.#initVisibilityPause();

      this.#onScroll = this.#updateArrows.bind(this);
      this.#onResize = this.#updateArrows.bind(this);
      this.track.addEventListener('scroll', this.#onScroll, { passive: true });
      window.addEventListener('resize', this.#onResize, { passive: true });

      requestAnimationFrame(() => this.#updateArrows());
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.#onScroll);
      window.removeEventListener('resize', this.#onResize);
      this.#observer?.disconnect();
    }

    #observer = null;
    #onScroll = null;
    #onResize = null;
    #reducedMotion = false;

    #initDrag() {
      let isDown = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;
      let pointerId = null;
      const DRAG_THRESHOLD = 5;

      const onDown = (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        // Ignore pointerdowns that originate on interactive elements (play button,
        // links, etc.) so their clicks fire normally instead of being swallowed
        // by pointer capture on the track.
        if (e.target.closest('button, a, [role="button"], input, select, textarea')) return;
        isDown = true;
        moved = false;
        startX = e.pageX;
        startScroll = this.track.scrollLeft;
        pointerId = e.pointerId;
      };

      const onMove = (e) => {
        if (!isDown) return;
        const walk = e.pageX - startX;
        // Defer capture + dragging state until movement actually crosses the
        // threshold — this keeps taps/clicks working on child elements.
        if (!moved && Math.abs(walk) > DRAG_THRESHOLD) {
          moved = true;
          this.track.classList.add('is-dragging');
          try { this.track.setPointerCapture(pointerId); } catch (_) {}
        }
        if (moved) {
          this.track.scrollLeft = startScroll - walk;
        }
      };

      const onUp = () => {
        if (!isDown) return;
        isDown = false;
        if (moved) {
          this.track.classList.remove('is-dragging');
          try { this.track.releasePointerCapture(pointerId); } catch (_) {}
        }
        pointerId = null;
      };

      this.track.addEventListener('pointerdown', onDown);
      this.track.addEventListener('pointermove', onMove);
      this.track.addEventListener('pointerup', onUp);
      this.track.addEventListener('pointercancel', onUp);

      // Swallow click events that happen at the end of a drag so the play button
      // doesn't fire when the user was actually dragging the slider.
      this.track.addEventListener('click', (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);

      // Prevent native drag on images/videos
      this.track.addEventListener('dragstart', (e) => e.preventDefault());
    }

    #initArrows() {
      this.prevBtn?.addEventListener('click', () => this.#scrollByStep(-1));
      this.nextBtn?.addEventListener('click', () => this.#scrollByStep(1));
    }

    #scrollByStep(direction) {
      const slide = this.track.querySelector('.video-slider__slide');
      if (!slide) return;
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const amount = (slide.offsetWidth + gap) * direction;
      this.track.scrollBy({
        left: amount,
        behavior: this.#reducedMotion ? 'auto' : 'smooth'
      });
    }

    #updateArrows() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = this.track.scrollLeft;
      this.prevBtn?.toggleAttribute('disabled', left <= 1);
      this.nextBtn?.toggleAttribute('disabled', left >= max - 1);
    }

    #initPlayButtons() {
      const slides = this.querySelectorAll('.video-slider__slide');

      for (const slide of slides) {
        const video = slide.querySelector('[data-video]');
        const button = slide.querySelector('[data-play-toggle]');
        if (!video || !button) continue;

        button.addEventListener('click', (e) => {
          e.stopPropagation();
          if (video.paused) {
            // One video at a time — pause others when starting a new one
            for (const other of this.querySelectorAll('[data-video]')) {
              if (other !== video && !other.paused) other.pause();
            }
            video.play().catch((err) => console.warn('[video-slider] play() failed:', err));
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', () => {
          slide.classList.add('is-playing');
          button.setAttribute('aria-pressed', 'true');
          button.setAttribute('aria-label', 'Pausar');
        });

        video.addEventListener('pause', () => {
          slide.classList.remove('is-playing');
          button.setAttribute('aria-pressed', 'false');
          button.setAttribute('aria-label', 'Reproducir');
        });

        video.addEventListener('ended', () => {
          slide.classList.remove('is-playing');
          button.setAttribute('aria-pressed', 'false');
        });
      }
    }

    // Pause videos that scroll completely out of view to save bandwidth/CPU.
    // Videos are never auto-played — this observer only pauses.
    #initVisibilityPause() {
      const videos = this.querySelectorAll('[data-video]');
      if (!videos.length || !('IntersectionObserver' in window)) return;

      this.#observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting && !entry.target.paused) {
            entry.target.pause();
          }
        }
      }, { threshold: 0.1 });

      for (const video of videos) this.#observer.observe(video);
    }
  }

  if (!customElements.get('video-slider')) {
    customElements.define('video-slider', VideoSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
